import React, { useEffect, useState } from "react";
import { WebDomain } from "../../common";

function Error404() {
    const [isOpen, setIsOpen] = useState(true);
    useEffect(() => {
        window
            .$("#meet-modal")
            .modal(
                isOpen
                    ? {
                        backdrop: "static",
                        keyboard: false,
                        focus: true,
                        show: true,
                      }
                    : "hide"
            );
    }, [isOpen]);

    return (
        <div
            className={`modal fade bd-example-modal-sm`}
            id="meet-modal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
        >
            <div
                className="modal-dialog  modal-md2 session-modal-dialog end-call-popup"
                role="document"
            >
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="session-modal-logo">
                            <a href={void 0} className="navbar-brand">
                                <img
                                    src="public/assets/images/logo_2.svg"
                                    alt="1"
                                />
                            </a>
                        </div>
                        <div className="session-modal-content">
                            <h2>END MEETING</h2>
                            <p>
                                Thanks for choosing Nxatel Meet! <br />
                                Click on button to redirect to Nxatel website.
                            </p>
                            <div className="session-modal-btns">
                                <a
                                    href={void 0}
                                    className="btn btn-orange"
                                    onClick={() => {
                                        window.location.href = `https://${WebDomain}`;
                                    }}
                                >
                                    Back to Nxatel
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Error404;
